import { render, staticRenderFns } from "./StatisticPage.vue?vue&type=template&id=1381afb0&scoped=true&"
import script from "./StatisticPage.vue?vue&type=script&lang=js&"
export * from "./StatisticPage.vue?vue&type=script&lang=js&"
import style0 from "./StatisticPage.vue?vue&type=style&index=0&id=1381afb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1381afb0",
  null
  
)

export default component.exports